import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "watch-lists-page__content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Statistics = _resolveComponent("Statistics")!
  const _component_SettingsBar = _resolveComponent("SettingsBar")!
  const _component_NTable = _resolveComponent("NTable")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_SettingsPageLayout = _resolveComponent("SettingsPageLayout")!

  return (_openBlock(), _createBlock(_component_SettingsPageLayout, null, {
    default: _withCtx(() => [
      _createVNode(_component_SettingsBar, {
        "create-label-i18-n": "common.watch_list_create",
        "has-create": _ctx.modelAcl.add,
        onSearch: _cache[0] || (_cache[0] = (v) => (_ctx.module.filter.current.name_contains = v)),
        onCreate: _ctx.handleCreate
      }, {
        stats: _withCtx(() => [
          _createVNode(_component_Statistics, { module: _ctx.module }, null, 8, ["module"])
        ]),
        _: 1
      }, 8, ["has-create", "onCreate"]),
      (_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_NTable, {
              columns: _ctx.columns,
              content: _ctx.items,
              "selected-items-ids": _ctx.selectedItemsIds,
              "disabled-items-ids": _ctx.disabledItemIds,
              onAction: _ctx.handleTableAction,
              onSort: _ctx.handleTableSort,
              "onSelect:changes": _ctx.handleSelectChanges
            }, null, 8, ["columns", "content", "selected-items-ids", "disabled-items-ids", "onAction", "onSort", "onSelect:changes"]),
            _createVNode(_component_InfiniteScroll, {
              filters: _ctx.module.filter.current,
              onLoadMore: _cache[1] || (_cache[1] = () => _ctx.module.append())
            }, null, 8, ["filters"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}